import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { fetchSpecialtyProfilesCodeSetValue } from "app/main/specialtyProfiles/actions/specialtyProfiles.actions";

const useSpecialtiesCodeSetValues = ({
  orgUnitId,
  specialtyIds,
  codeSetTypeCode,
  shouldLoad,
  onDataLoaded,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [codeSetValues, setCodeSetValues] = useState([]);
  const timer = useRef();
  const onDataLoadedRef = useRef(onDataLoaded);

  useEffect(() => {
    onDataLoadedRef.current = onDataLoaded;
  }, [onDataLoaded]);

  const loadOptions = isMounted => {
    setLoading(true);
    // Force load set to true to avoid bailout when multiple components fetch simultaneously
    dispatch(fetchSpecialtyProfilesCodeSetValue(orgUnitId, { specialtyIds, codeSetTypeCode }, true))
      .then(response => {
        if (!isMounted.current) return;

        const data = response?.payload?.specialtiesCodeSetValues || [];
        setCodeSetValues(data);
        if (onDataLoadedRef.current) {
          onDataLoadedRef.current(data);
        }
      })
      .finally(() => {
        if (isMounted.current) {
          setLoading(false);
        }
      });
  };

  useEffect(() => {
    const isMounted = { current: true };

    if (shouldLoad) {
      timer.current = setTimeout(() => {
        loadOptions(isMounted);
      }, 300); // Debounce load by 300ms to prevent rapid calls when multiple components mount simultaneously
    }

    return () => {
      isMounted.current = false;
      clearTimeout(timer.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(specialtyIds), shouldLoad, orgUnitId, codeSetTypeCode]);

  return { loading, codeSetValues };
};

export default useSpecialtiesCodeSetValues;
